const PERSIAN_NUMBERS = '۰۱۲۳۴۵۶۷۸۹'
const ARABIC_NUMBERS = '٠١٢٣٤٥٦٧٨٩'
const ARABIC_TO_PERSIAN_MAP = {
    ك: 'ک',
    دِ: 'د',
    بِ: 'ب',
    زِ: 'ز',
    ذِ: 'ذ',
    شِ: 'ش',
    سِ: 'س',
    ى: 'ی',
    ي: 'ی'
}

export function toPersian(text) {
    if (!text) return text
    text = text + ''

    for (let i = 0; i < 10; i++) {
        const replaceArToFa = new RegExp(ARABIC_NUMBERS[i], 'g')
        const replaceEnToFa = new RegExp(i, 'g')
        text = text
            .replace(replaceArToFa, PERSIAN_NUMBERS[i])
            .replace(replaceEnToFa, PERSIAN_NUMBERS[i])
    }
    for (const [arabic, persian] of Object.entries(ARABIC_TO_PERSIAN_MAP)) {
        const replaceFn = new RegExp(arabic, 'g')
        text = text.replace(replaceFn, persian)
    }

    return text
}

export const num_e2p = (s) => s?.replace(/\d/g, (d) => PERSIAN_NUMBERS[d])
export const num_e2a = (s) => s?.replace(/\d/g, (d) => ARABIC_NUMBERS[d])

export const num_p2e = (s) =>
    s?.replace(/[۰-۹]/g, (d) => PERSIAN_NUMBERS.indexOf(d))
export const num_a2e = (s) =>
    s?.replace(/[٠-٩]/g, (d) => ARABIC_NUMBERS.indexOf(d))

export const num_p2a = (s) =>
    s?.replace(/[۰-۹]/g, (d) => ARABIC_NUMBERS[PERSIAN_NUMBERS.indexOf(d)])
export const num_a2p = (s) =>
    s?.replace(/[٠-٩]/g, (d) => PERSIAN_NUMBERS[ARABIC_NUMBERS.indexOf(d)])

export const normalizeNumbers = (text) => num_a2e(num_p2e(text))
